import type { FaireProductEntity } from "../../entity_types/product";

export const p_xvvw2pry6x: FaireProductEntity = {
  token: "p_xvvw2pry6x",
  type: "product",
  name: "Spiced Pear - 9.5oz. Soy Wax Candle",
  brandToken: "b_5avawe9fjs",
  brandName: "Spirit Glow Home & Body Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/8fb2a3b153faf397047d8e02c8c266b4a64c6e5718660133115cfe8fa3e950e7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/61f846722de21b32c370ed8fca23b60d8ac6ab4ff451a481c902b7196275eb98.png",
    "https://cdn.faire.com/fastly/c1ccc4fc42e23d3f95491abebe46288e7e14bc32afac115f679cfadb4ff75f62.png",
  ],
  priceDollars: 15,
  description:
    'This fall, elevate your space with our limited-edition candle collection, where chic design meets cozy autumn vibes. Each glossy jar is elegantly crafted in a distinct fall hue: Pumpkin Marshmallow in rich orange, Vanilla Chai Latte in creamy ivory, Brown Sugar & Fig in warm ginger, Spiced Pear in chic sage & Cinnamon Apple in a wine red. Each 9.5-ounce jar holds premium soy wax, carefully hand-poured, and features double lead-free cotton wicks for a clean, even burn. Indulge in the essence of autumn, wrapped in sophistication, and perfect for any space.\n\nCandle Information:\n• 9.5 oz. Net Weight\n• Height: 3.75\n• Width: 3.5"\n• Glossy Glass Jar with Cork Lid\n• Burn Time: 35-40 Hours\n• Lead-Free Cotton Wicks\n• Natural Soy Wax\n• Premium, Non-Toxic, Clean Fragrance Oils\n• Phthalate Free, Non-Toxic, Cruelty Free\n• Hand-poured in Fort Myers Florida\n\nCandle Care Instructions:\nTrimming the wicks 1/4" before each burn reduces carbon build-up and soot, and it helps increase the lifespan of the candle.\nIt also allows the candle to burn slower and cooler.',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:04.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
